import Intro from "../../components/home/intro";
import QuickAccess from "../../components/home/quickAccess";
import Services from "../../components/home/services";
import Statistics from "../../components/home/statistics";
import QuestionAnswers from "../../components/home/questionAnswers";
import GetStarted from "../../components/home/getStarted";
import {Helmet} from "react-helmet";

const Home = () => {

    return (
        <>
            <Helmet>
                <title>میلفا</title>
            </Helmet>
            <Intro/>
            <QuickAccess/>
            <Services/>
            <Statistics/>
            <QuestionAnswers/>
            <GetStarted/>
        </>
    )
}
export default Home;
